import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import { newKitchenHeaderModalContent, newKitchenHeaderModalTitle } from '../../new-kitchen-header-styles';

export const Showrooms = () => (
  <>
    <ModalHeader className={newKitchenHeaderModalTitle} title="Шоурумы в&nbsp;112 магазинах" />
    <ModalContent className={newKitchenHeaderModalContent}>
      <Typography variant="m" size="body_long">
        Приезжайте в&nbsp;гости в&nbsp;любой удобный гипермаркет&nbsp;&mdash; вы&nbsp;сможете увидеть кухни
        вживую, оценить их&nbsp;качество и&nbsp;стиль, а&nbsp;наши специалисты с&nbsp;радостью помогут
        реализовать проект, подберут необходимую технику и&nbsp;оформят услуги.
      </Typography>
    </ModalContent>
  </>
);
